import React from "react";
import { useMessageSource } from "react-message-source";
import GTM from "../../util/tracking/gtm";
import {
  EventCategory,
  PERSON_ADDED_ACTION_VALUE,
} from "../../util/tracking/types";
import MultiForm from "../shared/components/multi-form";
import { createDefaultAttorneyData } from "./defaults";
import Person from "./person";
import { PersonType } from "./types";

interface PersonsProps {
  formData: PersonType[];
  name: string;
}

export default function Persons(props: PersonsProps): React.JSX.Element {
  const { formData, name } = props;

  const { getMessage } = useMessageSource();

  return (
    <MultiForm
      name={name}
      formData={formData}
      addButtonText={getMessage("Attorneys.addButton-text")}
      removeButtonText={getMessage("Attorneys.removeButton-text")}
      renderFormComponent={(data, dataPath) => (
        <Person {...data} dataPath={dataPath} />
      )}
      createDefaultItemData={createDefaultAttorneyData}
      limit={2}
      onAddItem={() => {
        GTM.trackEvent(
          EventCategory.AuthorizedRepresentative,
          PERSON_ADDED_ACTION_VALUE,
        );
      }}
    />
  );
}
